var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMutation } from "react-query";
import { LoyaltyApi } from "../../services/loyalty";
export const usePurchaseLoyaltyPrize = () => {
    const { isError, isLoading, mutateAsync, error, reset, data } = useMutation((_a) => __awaiter(void 0, [_a], void 0, function* ({ ciam_token, consumer_uuid, prize_uuid, quantity }) {
        const loyaltyClient = LoyaltyApi.init();
        const data = yield loyaltyClient.buyPrize(consumer_uuid, prize_uuid, quantity, ciam_token);
        return data;
    }));
    return {
        data,
        reset,
        error,
        isError,
        isLoading,
        purchaseLoyaltyPrize: mutateAsync,
    };
};
//# sourceMappingURL=usePurchaseLoyaltyPrize.js.map